export default __webpack_public_path__ + "static/media/GalanoGrotesque-Medium.ea0efc4a.woff2";